import { render, staticRenderFns } from "./BusinessUnitUpload.vue?vue&type=template&id=32279a78&scoped=true"
import script from "./BusinessUnitUpload.vue?vue&type=script&lang=js"
export * from "./BusinessUnitUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32279a78",
  null
  
)

export default component.exports